import React from "react";
import { Canvas } from "@react-three/fiber";
import {
  Html,
  OrbitControls,
  PivotControls,
  Environment,
} from "@react-three/drei";
import * as THREE from "three";

type Props = {
  /** When true, shows PivotControls; when false, hides them */
  editing?: boolean;
  title: string;
  content: string;
  /** Optional callbacks for the Html buttons */
  onPrimary?: () => void;
  onSecondary?: () => void;
  handleSceneChosen?: (scene: number) => void;
  location: THREE.Vector3;
};

export default function WelcomeStart({
  editing = false,
  onPrimary,
  title,
  content,
  onSecondary,
  handleSceneChosen,
  location,
}: Props) {
  // refs to the outer group (ground) and the Html wrapper so we can orient them
  const groundRef = React.useRef<THREE.Group | null>(null);
  const htmlWrapperRef = React.useRef<THREE.Group | null>(null);

  React.useEffect(() => {
    const target = new THREE.Vector3(0, 0, 0);
    if (groundRef.current) groundRef.current.lookAt(target);
    if (htmlWrapperRef.current) htmlWrapperRef.current.lookAt(target);
  }, []);

  return (
    <group ref={groundRef} position={location} scale={1}>
      {/* Html UI card floating above the box */}
      <group ref={htmlWrapperRef}>
        <Html
          transform
          position={[0, 0, 0]} // float above the box
          // rotation={[-0.4, 0, -0.01]} // slight backward tilt (~10°)
          distanceFactor={4} // scale with camera distance
          occlude // hide when obstructed
          pointerEvents="auto" // allow button clicks
        >
          <div
            style={{
              width: 220,
              height: 380,
              padding: "14px 16px",
              borderRadius: 16,
              background: "rgba(255, 255, 255, 0.85)",
            }}
          >
            <div
              style={{
                fontSize: 18,
                fontWeight: 700,
                color: "#0f172a",
                marginBottom: 10,
                letterSpacing: 0.2,
              }}
            >
              {title}
            </div>

            <div
              style={{
                fontSize: 13,
                fontWeight: 700,
                color: "#0f172a",
                marginBottom: 10,
                letterSpacing: 0.2,
              }}
            >
              <div dangerouslySetInnerHTML={{ __html: content }} />
            </div>

            <div style={{ display: "grid", gap: 8 }}>
              <button
                onClick={() => handleSceneChosen && handleSceneChosen(1)}
                style={{
                  height: 36,
                  borderRadius: 10,
                  border: "none",
                  cursor: "pointer",
                  fontWeight: 600,
                  background: "#2563eb",
                  color: "white",
                  boxShadow: "0 6px 14px rgba(37,99,235,0.35)",
                }}
              >
                Enter
              </button>
            </div>
          </div>
        </Html>
      </group>
    </group>
  );
}
